import Vue from 'vue'
import Router from 'vue-router'
import Public from './views/Public.vue'
import Secure from './views/Secure.vue'
import DRE from './views/DRE/DRE.vue'
import { verificaAcesso } from './routesAccess'

import DePara from './views/DePara/DePara.vue'
import DeParaRouterView from './views/DePara/DeParaRouterView.vue'
import NotFound from './views/NotFound.vue'
import Upload from './views/Upload/Upload'
import Relatorio from './views/Relatorio/Relatorio'
import Sincronizacao from './views/Sincronizacao/Sincronizacao'
import Empresas from './views/Empresas/Empresas'
import Webservice from './views/Webservice/Webservice'
import Usuario from './views/Usuario/Usuario'

import Home from './views/Home.vue'
import ResetPassword from './views/ResetPassword.vue'
import FluxoDeCaixa from './views/FluxoDeCaixa/FluxoDeCaixa.vue'
import Cluster from './views/Cluster/Cluster.vue'
import semPermissao from './views/semPermissao'
import Desconectar from './views/Desconectar.vue'
import { Franqueado } from './views/DePara/routes/Franqueado'
import { Franqueador } from './views/DePara/routes/Franqueador'

import IndiceDeGestao from './views/IndiceDeGestao/IndiceDeGestao.vue'
//import Construcao from './views/Construcao.vue'

const deparaNovo = [
    {
        path: '/de-para',
        name: 'de-para',
        component: DePara,
        beforeEnter: verificaAcesso,
        meta: { requiresAuth: true, rule: 'DePara' },
    },
    {
        path: '/de-para/franqueado',
        name: 'de-para-franqueado',
        component: DeParaRouterView,
        beforeEnter: verificaAcesso,
        meta: { requiresAuth: true, rule: 'DePara' },
        children: [
            ...Franqueado,
        ]
    },
    {
        path: '/de-para/franqueador',
        name: 'de-para-franqueador',
        component: DeParaRouterView,
        beforeEnter: verificaAcesso,
        meta: { requiresAuth: true, rule: 'DePara' },
        children: [
            ...Franqueador,
        ]
    }
]

Vue.use(Router);

export default new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'public',
            components: {
                public: Public
            }
        },
        {
            path: '/404',
            name: '404public',
            components: {
                public: NotFound
            },
            meta: { requiresAuth: false }
        },
        {
            path: '/',
            name: 'secure',
            redirect: '/home',
            components: {
                secure: Secure,
                meta: { requiresAuth: true }
            },
            children: [
                {
                    path: '/semPermissao',
                    name: 'semPermissao',
                    component: semPermissao,
                    meta: { requiresAuth: true, rule: '' },
                },
                {
                    path: '/home',
                    name: 'home',
                    component: Home,
                    // component: Construcao,
                    meta: { requiresAuth: true, rule: '' }
                },
                {
                    path: '/reset-password/:token',
                    name: 'reset-password',
                    component: ResetPassword,
                    meta: { requiresAuth: false },
                },
                {
                    path: '/dre',
                    name: 'dre',
                    component: DRE,
                    beforeEnter: verificaAcesso,
                    meta: { requiresAuth: true, rule: 'DRE' }
                },
                {
                    path: '/fluxo-de-caixa',
                    name: 'fluxo-de-caixa',
                    component: FluxoDeCaixa,
                    //component: Construcao,
                    beforeEnter: verificaAcesso,
                    meta: { requiresAuth: true, rule: 'FluxoDeCaixa' },
                },
                {
                    path: '/indice-de-gestao',
                    name: 'indice-de-gestao',
                    component: IndiceDeGestao,
                    beforeEnter: verificaAcesso,
                    meta: { requiresAuth: true, rule: 'IndiceDeGestao' }
                },
                {
                    path: '/cluster',
                    name: 'cluster',
                    component: Cluster,
                    //component: Construcao,
                    beforeEnter: verificaAcesso,
                    meta: { requiresAuth: true, rule: 'Cluster' }
                },
                ...deparaNovo,
                {
                    path: '/upload',
                    name: 'upload',
                    component: Upload,
                    beforeEnter: verificaAcesso,
                    meta: { requiresAuth: true, rule: 'Arquivo'  }
                },
                {
                    path: '/relatorio',
                    name: 'relatorio',
                    component: Relatorio,
                    beforeEnter: verificaAcesso,
                    meta: { requiresAuth: true, rule: 'Relatorio'  }
                },
                {
                    path: '/sincronizacao',
                    name: 'sincronizacao',
                    component: Sincronizacao,
                    beforeEnter: verificaAcesso,
                    meta: { requiresAuth: true, rule: 'Sincronizacao'  }
                },
                {
                    path: '/empresas',
                    name: 'empresas',
                    component: Empresas,
                    beforeEnter: verificaAcesso,
                    meta: { requiresAuth: true, rule: 'Empresa'  }
                },
                {
                    path: '/webservice',
                    name: 'webservice',
                    component: Webservice,
                    beforeEnter: verificaAcesso,
                    meta: { requiresAuth: true, rule: 'Webservice'  }
                },
                {
                    path: '/usuarios',
                    name: 'usuarios',
                    component: Usuario,
                    beforeEnter: verificaAcesso,
                    meta: { requiresAuth: true, rule: 'usuarios'  }
                },
                {
                    path: '/desconectar',
                    name: 'desconectar',
                    component: Desconectar,
                    meta: { requiresAuth: false },
                },
                { path: '*', redirect: '/404' }, 
            ]
        }
        
    ],
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
})
